import React from 'react';
const idStamp = Date.now().toString() + Math.random().toString();
const filler = function(props) {
   return <img onClick={props.navigationFunction} src="https://s3.us-east-2.amazonaws.com/arrowpos-assets/recurve_filler_images/filler_2_item.png" alt="Filler" className='clickable-element card-img-top card-img item-card-img' />
}
export default filler;